import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import InlineEdit from './InlineEdit';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  height: auto;
`;

class InlineEditGroup extends React.Component {
  static propTypes = {
    edit: PropTypes.object,
    error: PropTypes.object,
    hideIcon: PropTypes.bool,
    inputProps: PropTypes.object,
    inputMaskProps: PropTypes.object,
    inputRef: PropTypes.object,
    isSaving: PropTypes.bool,
    onSave: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    style: PropTypes.object,
    template: PropTypes.any,
    data: PropTypes.any,
  };

  static defaultProps = {
    edit: undefined,
    error: '',
    hideIcon: false,
    inputProps: {},
    inputMaskProps: undefined,
    inputRef: undefined,
    isSaving: false,
    onSave: undefined,
    onBlur: undefined,
    onChange: undefined,
    style: undefined,
    template: undefined,
    data: undefined,
  };

  stringTemplate = str => (
    // when the str is empty === "" then return nothing
    // when a string is a space === " " then return a empty span as a placeholder in the array
    // else return the string in a Col
    <If condition={!!str}>
      <If condition={!!str.trim()}>
        <div style={{ whiteSpace: 'pre' }}>{str}</div>
      </If>
      <If condition={!str.trim()}>
        <span />{' '}
      </If>
    </If>
  );

  templateToInline = (templateStr, data) => {
    // get all variables from the template and put them into an array
    // out of that array create InlineEdit Components for each
    let variableRegEx = /\{([A-z]+)\}/g;
    let varStrings = templateStr.match(variableRegEx);
    let editable = varStrings.map(stringWithBrackets => {
      let dataProp = stringWithBrackets.replace(/\{|\}/g, ''); // replace
      let dataVal = data[dataProp];

      return (
        <div key={dataVal}>
          <InlineEdit
            inputProps={this.props.inputProps}
            inputMaskProps={this.props.inputMaskProps}
            hideIcon={this.props.hideIcon}
            error={this.props.error && this.props.error[dataProp]}
            edit={this.props.edit && !!this.props.edit[dataProp]}
            inputRef={this.props.inputRef && this.props.inputRef[dataProp]}
            onBlur={(value, event) => {
              if (typeof this.props.onBlur === 'function') {
                this.props.onBlur(value, dataProp, event);
              }
            }}
            onSave={(value, event) => {
              if (typeof this.props.onSave === 'function') {
                this.props.onSave(value, dataProp, event);
              }
            }}
            onChange={(dataKey, value, event) => {
              if (typeof this.props.onChange === 'function') {
                this.props.onChange(value, dataProp, event);
              }
            }}
            text={dataVal}
            isSaving={this.props.isSaving}
          />
        </div>
      );
    });

    // reterieve all normal non template variables, put those into an array
    let commonStringRegEx = /\{[A-z]+\}/;
    let commonStrings = templateStr.split(commonStringRegEx);
    let strings = commonStrings
      .map(this.stringTemplate)
      .filter(s => s !== null);

    return {
      strings,
      editable,
    };
  };

  render() {
    let templateObj = this.templateToInline(
      this.props.template,
      this.props.data,
    );
    return (
      <If condition={templateObj.strings}>
        <Wrapper style={this.props.style}>
          {templateObj.strings.map((StringNode, index) => {
            let editNode = templateObj.editable[index];

            // combine the strings and InlineEdit components based on index
            return (
              <React.Fragment key={index.toString()}>
                {StringNode}
                {editNode}
              </React.Fragment>
            );
          })}
        </Wrapper>
      </If>
    );
  }
}

export default InlineEditGroup;
